/*
 Copyright (c) 2022 Skyflow, Inc.
*/
abstract class Container {
  abstract type: string;
}

export default Container;
